module.exports = __webpack_public_path__ + "static/big-data-benchmarks-3580ba82aa1735df497b8e0933d0a431.mp4";